<template>
  <v-container style="height: 400px" v-if="loading" class="model-loading">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="subtitle-1 text-center" cols="12">
        {{ $t("please_wait") }} ....
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          :color="progressColor"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    loading: Boolean,
  },
  computed: {
    // lee footerColor desde el state del módulo 'common'
    ...mapState("common", ["footerColor"]),

    // color final para el progress: Vuex -> CSS var -> fallback
    progressColor() {
      // 1) desde Vuex (reactivo)
      const fromStore = this.footerColor && this.footerColor.trim() ? this.footerColor.trim() : null;
      if (fromStore) return fromStore;

      // 2) fallback: variable CSS --footer-bg-color (si la estás seteando en documentElement)
      const cssVar = getComputedStyle(document.documentElement).getPropertyValue('--footer-bg-color').trim();
      if (cssVar) return cssVar;

      // 3) color por defecto
      return "#043351";
    }
  },
};
</script>


